import { render, staticRenderFns } from "./ServerGroup.vue?vue&type=template&id=63a6bff4&"
import script from "./ServerGroup.vue?vue&type=script&lang=js&"
export * from "./ServerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports